import React from 'react'
import PageTitle from '../../UI/PageTitle'
import { useTranslation } from 'react-i18next'
import InvoicesLoader from './InvoicesLoader'

const Invoices = () => {
  const { t } = useTranslation()
  return (
    <div className='shadow-form rounded-20px p-5 sm:p-10 mt-6'>
      <PageTitle title={t('myInvoices')} />
      <p className='mt-2 text-sm text-lightGray'>{t('invoiceHistoryNote')}</p>
      <InvoicesLoader />
    </div>
  )
}

export default Invoices
